
export default {
  name: 'Tooltip',
  components: {
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    contentTitle: {
      type: String,
      default: null
    },
    useSlot: {
      type: Boolean,
      default: true
    },
    iconGray: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      tooltip: false,
    }
  },
}
